<template>
  <div class="container mx-auto">
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="3" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <span
              ><i class="fas fa-cash-register"></i>&nbsp;<b
                >Reporte de cajas</b
              ></span
            >
            <button
              @click="mtdBack"
              type="button"
              class="btn btn-sm text-white"
              style="background: #e46666"
            >
              <i class="fas fa-hand-point-left"></i> Retroceder
            </button>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="12" xl="12" v-if="$store.getters.get_rol.id !== 7">
                <cSelectForm
                  label="Sede"
                  placeholder="Seleccione una sede"
                  :options="campus"
                  :value.sync="filter.campu"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                <CInput
                  type="date"
                  v-model="filter.initial"
                  :max="hoy"
                  label="Desde"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                <CInput
                  type="date"
                  v-model="filter.end"
                  :max="hoy"
                  label="Hasta"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                <CButton
                  type="button"
                  class="btn btn-sm btn-info w-100"
                  @click="mtdGetSearch"
                  :disabled="cpDisabled"
                >
                  <i class="fas fa-search"></i>&nbsp;Buscar
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="8" lg="9" xl="9" v-if="dataBead.length > 0">
        <CRow>
          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex justify-content-center">
              <CButton
                class="btn btn-sm btn-info"
                :disabled="cpBack"
                @click="backPage"
                ><i class="fas fa-arrow-alt-circle-left"></i
              ></CButton>
              <CInput
                type="text"
                class="form-control-sm"
                style="
                  align-items: center;
                  text-align: center;
                  font-weight: bold;
                "
                v-model="paginate.info"
                readonly
              ></CInput>
              <CButton
                class="btn btn-sm btn-info"
                :disabled="cpNext"
                @click="nextPage"
                ><i class="fas fa-arrow-alt-circle-right"></i
              ></CButton>
            </div>
          </CCol>
          <CCol xs="12" sm="12" md="12" lg="12" xl="12" class="mt-2">
            <CRow class="mt-2">
              <CCol xs="12" sm="12" md="12" lg="3" xl="3">
                Usuario: {{ selectBead.user.name }}
                {{ selectBead.user.last_name }}
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="3" xl="3">
                Caja: {{ selectBead.box.name }}
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="3" xl="3">
                Apertura: {{ formatDate(selectBead.date_initial) }}
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="3" xl="3">
                Cierre: {{ formatDate(selectBead.date_final) }}
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-2">
                <CCard>
                  <CCardHeader class="bg-gris text-center font-weight-bold">
                    <span>Total Efectivo</span>
                  </CCardHeader>
                  <CCardBody class="border">
                    <div>Apertura: {{ selectBead.initial }}</div>
                  </CCardBody>
                  <CCardBody class="border" style="cursor: pointer">
                    <div>Ingresos: {{ selectBead.income }}</div>
                  </CCardBody>
                  <CCardBody class="border" style="cursor: pointer">
                    <div>Egresos: {{ selectBead.expense }}</div>
                  </CCardBody>
                  <CCardBody class="border" style="cursor: pointer">
                    <div>Retiros: {{ selectBead.retirement }}</div>
                  </CCardBody>
                  <CCardBody
                    class="border"
                    style="cursor: pointer"
                    @click="mtdOpenModalMovement('deposito')"
                  >
                    <div>Depósito: {{ selectBead.deposit }}</div>
                  </CCardBody>
                  <CCardBody class="border">
                    <div>
                      <b>Total: {{ selectBead.final }} </b>
                    </div>
                  </CCardBody>
                </CCard>
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-2">
                <CCard>
                  <CCardHeader class="bg-gris text-center font-weight-bold">
                    <span>Otros Ingresos</span>
                  </CCardHeader>
                  <template v-for="(method, index) in data_methodpayment">
                    <CCardBody
                      v-if="method.name != 'EFECTIVO'"
                      :key="index"
                      class="border"
                      style="cursor: pointer"
                    >
                      <div>
                        {{ method.name }}: {{ getMethodValue(method.name) }}
                      </div>
                    </CCardBody>
                  </template>
                </CCard>
                <div class="d-flex justify-content-end"></div>
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-2">
                <CCard>
                  <CCardHeader class="bg-gris text-center font-weight-bold">
                    <span>Otros Egresos {{ expenseOther.length }}</span>
                  </CCardHeader>
                  <template v-if="expenseOther.length > 0">
                    <template v-for="(item, index) in castExpense">
                      <CCardBody
                        v-if="item.name != 'EFECTIVO'"
                        :key="index"
                        class="border"
                        style="cursor: pointer"
                        @click="handleMethodPaymentEgreso(item.name)"
                      >
                        <div>
                          {{ item.name }}:
                          {{ parseFloat(item.amount).toFixed(2) }}
                        </div>
                      </CCardBody>
                    </template>
                  </template>
                  <template v-else>
                    <CCardBody class="border" style="cursor: pointer">
                      <div>NO TIENE OTROS EGRESOS</div>
                    </CCardBody>
                  </template>
                </CCard>
                <div class="d-flex justify-content-end"></div>
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="6" xl="6" class="mt-2">
                <CButton
                  @click="mtdViewArqueo"
                  class="w-100 btn btn-sm btn-primary"
                  ><i class="fas fa-eye"></i>&nbsp;Ver arquero</CButton
                >
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="6" xl="6" class="mt-2">
                <CButton @click="mtdViewPdf" class="w-100 btn btn-sm btn-info"
                  ><i class="fas fa-file-pdf"></i>&nbsp;Ver pdf</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <cModalViewArqueoVue
      :title="modalArqueo.title"
      :boo_modal="modalArqueo.modal_form"
      :billetes="modalArqueo.billetes"
      :monedas="modalArqueo.monedas"
      @closeModalArqueo="closeModalArqueo"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import cSelectForm from "../../../components/shared/inputs/cSelect.vue";
import cModalViewArqueoVue from "./modals/cModalViewArqueo.vue";

export default {
  name: "c-report-bead",
  components: { cSelectForm, cModalViewArqueoVue },
  data() {
    return {
      hoy: null,
      prefix: "/report/bead",
      filter: {
        campu: null,
        initial: null,
        end: null,
      },
      campus: [],
      dataBead: [],
      paginate: {
        page: 1,
        info: "",
      },
      selectBead: [],
      data_methodpayment: [],
      data_yape: [],
      data_plin: [],
      data_yape_reserva: [],
      data_plin_reserva: [],
      expenseOther: [],
      modalArqueo: {
        title: "Arqueo",
        modal_form: false,
        billetes:[],
        monedas:[]
      },
    };
  },
  computed: {
    cpDisabled() {
      if (
        this.filter.campu != null &&
        this.filter.initial != null &&
        this.filter.end != null
      )
        return false;
      return true;
    },
    cpBack() {
      if (this.paginate.page == 1) return true;
      return false;
    },
    cpNext() {
      if (this.paginate.page == this.dataBead.length) return true;
      return false;
    },
    castExpense() {
      let cast = [];
      this.selectBead.expenses.forEach((element) => {
        let temp = cast.filter((el) => el.name == element.method_payment.name);
        if (temp.length == 0) {
          cast.push({
            method_payment_id: element.method_payment_id,
            name: element.method_payment.name,
            amount: parseFloat(element.amount).toFixed(2),
          });
        } else {
          cast.forEach((el) => {
            if (el.name == element.method_payment.name) {
              el.amount = parseFloat(el.amount) + parseFloat(element.amount);
            }
          });
        }
      });
      this.expenseOther = cast;
      return cast;
    },
  },
  created() {
    moment.locale("es");
    this.hoy = moment().format("YYYY-MM-DD");
    this.filter.initial = this.hoy;
    this.filter.end = this.hoy;
    this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtdGetData: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          this.prefix +
          "/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.filter.campu = this.$store.getters.get_campu.id;
          this.campus = response.data.campu;
          this.data_methodpayment = response.data.methodPayment;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdGetSearch: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          this.prefix +
          "/getdata/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
        params: this.filter,
      })
        .then((response) => {
          this.dataBead = response.data;
          this.paginate.info = "1/" + this.dataBead.length;
          this.selectBead = response.data[0];
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    backPage: function () {
      if (this.paginate.page > 1) {
        this.paginate.page -= 1;
        this.paginate.info = this.paginate.page + "/" + this.dataBead.length;
        this.selectBead = this.dataBead[this.paginate.page - 1];
      }
    },
    nextPage: function () {
      if (this.paginate.page < this.dataBead.length) {
        this.paginate.page += 1;
        this.paginate.info = this.paginate.page + "/" + this.dataBead.length;
        this.selectBead = this.dataBead[this.paginate.page - 1];
      }
    },
    getMethodValue(methodName) {
      switch (methodName) {
        case "TRANSFERENCIA":
          return this.selectBead.transfer;
        case "TARJETA":
          return this.selectBead.card;
        case "DEPOSITO":
          return this.selectBead.deposit;
        case "YAPE":
          return this.sumaYape();
        case "PLIN":
          return this.sumaPlin();
        default:
          return null;
      }
    },
    sumaYape() {
      const allYapeData = [...this.data_yape, ...this.data_yape_reserva];
      const suma = allYapeData.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    sumaPlin() {
      const allPlinData = [...this.data_plin, ...this.data_plin_reserva];
      const suma = allPlinData.reduce(
        (total, item) => total + parseFloat(item.amount),
        0
      );
      const total = suma.toFixed(2);
      return total;
    },
    mtdViewPdf: function () {
      if (this.selectBead.date_final != null) {
        window.open(
          this.$store.getters.get__url +
            "/beads/viewpdfreportegeneral/" +
            this.$store.getters.get_campu.id +
            "/" +
            this.selectBead.id,
          "_blank"
        );
      } else {
        Swal.fire({
          title: "La caja no tiene cierre",
          icon: "warning",
        });
      }
    },
    mtdViewArqueo: function () {
      if (this.selectBead.date_final != null) {
        this.modalArqueo.modal_form = true;
        let transaction = (JSON.parse(this.selectBead.transaction.json_cierre));
        this.modalArqueo.billetes = transaction.billetes;
        this.modalArqueo.monedas = transaction.monedas;
      } else {
        Swal.fire({
          title: "La caja no tiene cierre",
          icon: "warning",
        });
      }
    },
    closeModalArqueo: function () {
      this.modalArqueo = {
        title: "Arqueo",
        modal_form: false,
        billetes:[],
        monedas:[]
      };
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.form-control:disabled,
.form-control[readonly] {
  background-color: #f9fafc !important;
  /* opacity: 1; */
}
</style>